module.exports = __webpack_public_path__ + "static/media/coffee.6bfe6a45.svg";